var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Petty Cash Services")]),_c('p',[_vm._v("Welcome to the Petty Cash Services page. Here you can manage your petty cash transactions.")])])
}]

export { render, staticRenderFns }